import {
  Asset,
  Block,
  Link,
} from 'src/__generated__/graphqlTypes';
import { OptionalBgColorInterface } from 'types/componentTypes';

export interface ContactUsHelpCenterInterface extends OptionalBgColorInterface {
  title: Block;
  generalInfo: Block;
  chargeInfo: Block;
  isMobileViewWidth: boolean;
  mobileViewMaxWidth: string;
}

export enum HelpCenterContainerSlug {
  TITLE = 'title',
  GENERAL_INFO = 'generalInfo',
  NEWSLETTERS = 'newsletters',
  CHARGE_INFO = 'chargeInfo',
}

export enum HelpCenterImageSizeRatioSlug {
  MOBILE = 0.56,
  ENTRY_IMAGE = 0.5,
}

export interface TitleInterface {
  title: Block['richTitle'];
  content: Block['content'];
  id: Block['blockId'];
}

export interface GeneralInfoImageInterface {
  image?: Asset;
  mobileViewMaxWidth: string;
  isMobileViewWidth: boolean;
}

export interface GeneralInfoInterface {
  helpLinks?: Array<Link>;
  isMobileViewWidth: boolean;
  mobileViewMaxWidth: string;
}
